import deleteAttachment from './deleteAttachment';
import downloadAttachment from './downloadAttachment';
import { getFilesDownloadLinksBySessionIdAndTokenQuery } from './getFilesDownloadLinksBySessionIdAndTokenQuery';
import getFilesDownloadLinksBySessionIdQuery from './getFilesDownloadLinksBySessionIdQuery';
import getFilesUploadLinksBySessionIdCommand from './getFilesUploadLinksBySessionIdCommand';
import uploadAttachements from './uploadAttachment';
import uploadAttachmentWithProgress from './uploadAttachmentWithProgress';
import uploadFileAttachmentsOnSessionCommand from './uploadFileAttachmentsOnSessionCommand';
import uploadMultiAttachments from './uploadMultiAttachments';
import urlExists from './urlExists';

export const CommonAttachmentService = {
  uploadAttachements,
  uploadMultiAttachments,
  uploadAttachmentWithProgress,
  uploadFileAttachmentsOnSessionCommand,
  getFilesUploadLinksBySessionIdCommand,

  downloadAttachment,
  getFilesDownloadLinksBySessionIdQuery,
  getFilesDownloadLinksBySessionIdAndTokenQuery,

  deleteAttachment,
  urlExists,
};
